import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { CustomerSettings, LoyaltySettings, OfferSettings } from "../pages/api";

const initialState: CustomerSettings = {
  loyaltySettings: null,
  offerSettings: null,
};

export const customerSettingsSlice = createSlice({
  name: "customerSettings",
  initialState,
  reducers: {
    setLoyaltySettings: (
      state: any,
      action: PayloadAction<LoyaltySettings>,
    ) => {
      state.loyaltySettings = action.payload;
    },
    setOfferSettings: (
      state: any,
      action: PayloadAction<Array<OfferSettings>>,
    ) => {
      state.offerSettings = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoyaltySettings, setOfferSettings } =
  customerSettingsSlice.actions;

export default customerSettingsSlice.reducer;
